module.exports = __webpack_public_path__ + "img/img3.7060fe75.png";